<div *ngIf="deck.name != ''">
    <ul style="overflow:auto;block-size: 75%;font-family : 'Montserrat';font-weight: 100;">
      <h2 id="deck">{{deck.name}}</h2>
    </ul>
</div>
  